import { useContext, useState } from 'react';
import { CartContext } from '../context/CartContext';

const ProductCard = ({ product, user, onDelete, onEdit }) => {
    const { addToCart } = useContext(CartContext);
    const [quantity, setQuantity] = useState(1);
    const [added, setAdded] = useState(false);

    const handleAddToCart = () => {
        if (product.stock > 0) {
            addToCart(product, quantity);
            setAdded(true);
            setTimeout(() => setAdded(false), 2000); // Reset after 2 seconds
        }
    };

    return (
        <div className="product-card">
            {/* Edit/Delete Buttons - Only visible to logged-in users */}
            {user && onDelete && onEdit && (
                <div className="card-actions">
                    <button
                        className="action-btn edit-btn"
                        onClick={() => onEdit(product.id)}
                        title="Edit"
                    >
                        ✏️
                    </button>
                    <button
                        className="action-btn delete-btn"
                        onClick={() => onDelete(product.id)}
                        title="Delete"
                    >
                        🗑️
                    </button>
                </div>
            )}

            <div className="product-image">
                <img src={product.imageUrl} alt={product.name} />
                {product.stock === 0 && <div className="out-of-stock-badge">Out of Stock</div>}
            </div>
            <div className="product-info">
                <h3 className="product-name">{product.name}</h3>
                <p className="product-description">{product.description}</p>
                <div className="product-footer">
                    <span className="product-price">KSh {product.price.toFixed(2)}</span>
                    <span className="product-stock">
                        {product.stock > 0 ? `${product.stock} in stock` : 'Out of stock'}
                    </span>
                </div>

                {product.stock > 0 && (
                    <div className="product-actions">
                        <div className="quantity-selector">
                            <button
                                onClick={() => setQuantity(Math.max(1, quantity - 1))}
                                className="qty-btn"
                            >
                                -
                            </button>
                            <span className="qty-display">{quantity}</span>
                            <button
                                onClick={() => setQuantity(Math.min(product.stock, quantity + 1))}
                                className="qty-btn"
                            >
                                +
                            </button>
                        </div>
                        <button
                            onClick={handleAddToCart}
                            className={`btn-add-to-cart ${added ? 'added' : ''}`}
                        >
                            {added ? '✓ Added!' : 'Add to Cart'}
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ProductCard;
